module.exports = __webpack_public_path__ + "img/oftapproval.fba0193f.svg";